module.exports = function() {
  return new Worker(__webpack_public_path__ + "c5cfa4092ea5228d82dc.worker.js");
};